export default "__VITE_ASSET__BgBmrIIE__"